document.addEventListener("DOMContentLoaded", () => {
  try {
    import ("../../common/index");
    import ("../../common/search/search-validation-mobile");
    import ("../../common/search/search-validation-desktop");
    import ("../../common/sidebar/mobile-sidebar");
    import ("../../common/sidebar/desktop-item");
    import ("../../common/tags-cloud/tags-cloud-desktop");
    import ("../../common/tags-cloud/tags-cloud-mobile");
    import ("../../common/copy-button/copy-link-button");

    console.log("DOMContentLoaded, on category page");
  } catch (error) {
    console.error("An error occurred while loading the files on category page", error);
  }
});
